import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";
import { getCustomerName } from "../utils/orderDetailsUtils";

const CustomerInfoSection = ({ order }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="customer-info-section">
            <h2>{t('customerInformation')}</h2>
            <div className="info-row">
                <span className="info-label">{t('customerName')}:</span>
                <span className="info-value">{getCustomerName(order, t)}</span>
            </div>
            <div className="info-row">
                <span className="info-label">{t('customerEmail')}:</span>
                <span className="info-value">
                    {order.customerInfo?.email ||
                        order.billingInfo?.email ||
                        order.customer?.email ||
                        t('dateNotAvailable')}
                </span>
            </div>
            <div className="info-row">
                <span className="info-label">{t('customerPhone')}:</span>
                <span className="info-value">
                    {order.customerInfo?.phone || order.billingInfo?.phone || t('dateNotAvailable')}
                </span>
            </div>
        </div>
    );
};

export default CustomerInfoSection;